import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { AuthService } from 'src/app/auth.service';
import { ProjectService } from 'src/app/project.service';
import { ConnectionService, ConfirmService } from '@luzula/luzula-lib';

@Component({
    standalone: false,
    selector: 'bp-auth-button',
    templateUrl: './auth-button.component.html',
    styleUrls: ['./auth-button.component.css'],

})
export class AuthButtonComponent implements OnInit {
	auth = inject(AuthService);
	cs = inject(ConnectionService);
	confirmService = inject(ConfirmService);
	private ps = inject(ProjectService);

	@Output() loggedOut = new EventEmitter<void>();
	isOnline:boolean = navigator.onLine;

	constructor() {
		this.cs.monitor().subscribe((online: boolean) => {
			this.isOnline = online;
		})
	}

	ngOnInit(): void { }

	openLogin(): void {
		this.auth.login().subscribe();
	}

	async onLogout() {
		if (!this.isOnline) return;
		// User-Wunsch 2026-06-01: Wenn ein Projekt geladen ist, im Confirm
		// explizit auf das Entladen hinweisen — und nach erfolgreichem Logout
		// das Projekt sauber entladen, damit der nächste Login (auch anderer
		// User) nicht das fremde Projekt restauriert (Bug 2).
		const projectLoaded = !!this.ps.project();
		const message = projectLoaded
			? 'Wenn Sie sich abmelden, wird das aktuell geladene Projekt entladen. '
				+ 'Sie können keine Daten mehr ändern — die Daten bleiben aber erhalten.\n\n'
				+ 'Möchten Sie sich trotzdem abmelden?'
			: 'Wenn Sie sich abmelden, können Sie keine Daten mehr ändern. Die Daten bleiben aber erhalten.\n\n'
				+ 'Möchten Sie sich trotzdem abmelden?';
		const confirmed = await this.confirmService.confirm({
			title: 'Abmelden',
			message,
			confirmText: 'Abmelden',
			confirmClass: 'btn-warning'
		});
		if (!confirmed) return;
		// Projekt VOR dem auth.logout entladen — sonst läuft der Auto-Restore
		// im base-project.service.initialize evtl. ins Leere bzw. mit
		// fremdem User-Kontext.
		if (projectLoaded) {
			try { await this.ps.unloadCurrentProject(); } catch { /* still */ }
		}
		this.auth.logout(() => this.loggedOut.emit());
	}
}
